import { Mutator } from 'final-form';
import forEach from 'lodash/forEach';
import set from 'lodash/set';
import {
  Form as FinalForm,
  FormProps as FinalFormProps,
} from 'react-final-form';
import { ObjectSchema } from 'yup';
export * from 'react-final-form';

const validateSchema = (schema: any, onValidate: any) => (values: any) => {
  const errors = {};

  try {
    schema.validateSync(values, {
      abortEarly: false,
      context: values,
    });
  } catch (err) {
    forEach(err.inner, ({ path, message }) => set(errors, path, message));
  }

  if (onValidate) {
    const isValid = Object.keys(errors).length === 0;
    onValidate(isValid);
  }

  return errors;
};

export interface FormProps extends FinalFormProps {
  onSubmit<T>(values: T): void;
  onCancel?: () => void;
  arrayMutators?: { [key: string]: Mutator<any> };
  validationSchema?: ObjectSchema<any>;
}

export const Form = ({
  arrayMutators,
  validationSchema,
  onSubmit,
  onValidate,
  ...rest
}: Omit<FormProps, 'onCancel'>) => (
  <FinalForm
    onSubmit={onSubmit}
    mutators={arrayMutators}
    validate={validateSchema(validationSchema, onValidate)}
    {...rest}
  />
);

export default Form;
